import { render } from "./FaleConoscoView.vue?vue&type=template&id=52927eb8"
import script from "./FaleConoscoView.vue?vue&type=script&lang=js"
export * from "./FaleConoscoView.vue?vue&type=script&lang=js"

import "./FaleConoscoView.vue?vue&type=style&index=0&id=52927eb8&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__